import { create } from 'zustand';

export interface Profile {
  id: string;
  userId?: string;
  email?: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  initials?: string;
  persona?: string;
  roles?: string[];
  default?: boolean;
}

export interface Me {
  /** User id — the session `sid`, and the ADK userId for chat. */
  userId: string;
  profile: Profile;
}

interface ProfileState {
  me: Me | null;
  setMe: (me: Me | null) => void;
}

export const useProfileStore = create<ProfileState>((set) => ({
  me: null,
  setMe: (me) => set({ me }),
}));
